import { Avatar } from '@mui/material'
import type { Assistant } from 'types/graphql'

const AssistantAvatar = ({ assistant }: { assistant: Assistant }) => {
  return (
    <Avatar
      src={assistant?.photoUrl || '/logos/Day 1.png'}
      sx={{ border: (theme) => `0.6px solid ${theme.palette.divider}` }}
    />
  )
}

export default AssistantAvatar
